// @flow

import React from "react";
import moment from "moment";
import { DateRangePicker } from "react-dates";

type Props = {
  setDateFilter: Function,
  displayFormat: string
};

type State = {
  focusedInput: momentPropTypes.momentObj,
  startDate: momentPropTypes.momentObj,
  endDate: momentPropTypes.momentObj
};

class DateRangeFilter extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      focusedInput: null,
      startDate: moment()
        .subtract(7, "day")
        .startOf("day"),
      endDate: moment().endOf("day")
    };
    this.handleDateFilter = this.handleDateFilter.bind(this);
    this.onFocusChange = this.onFocusChange.bind(this);
  }

  componentDidMount() {
    this.setDefaultDateRange();
  }

  componentWillUnmount() {
    // Reset Date Filters to not affect table values
    this.props.setDateFilter(false, false);
  }

  onFocusChange(focusedInput?: Object) {
    this.setState({ focusedInput });
  }

  setDefaultDateRange() {
    if (this.props.setInitialDateAsNull) {
      this.setState({
        startDate: null,
        endDate: null
      });
      return;
    }
    const startDateEpoch = this.state.startDate.format("x");
    const endDateEpoch = this.state.endDate.format("x");
    this.props.setDateFilter(startDateEpoch, endDateEpoch);
  }

  handleDateFilter(startDateMomentObj?: Object, endDateMomentObj?: Object) {
    // If one of startDate or endDate is undefined(only one is selected), pass an empty string so all the rows get matched.
    if (!startDateMomentObj || !endDateMomentObj) {
      this.setState({
        startDate: startDateMomentObj,
        endDate: endDateMomentObj
      });
      this.props.setDateFilter(startDateMomentObj, endDateMomentObj);
      return;
    }
    // update store
    const selectedStartDate = startDateMomentObj.startOf("day").format("x");
    const selectedEndDate = endDateMomentObj.endOf("day").format("x");
    this.setState({
      startDate: startDateMomentObj,
      endDate: endDateMomentObj
    });
    this.props.setDateFilter(selectedStartDate, selectedEndDate);
  }

  render() {
    return (
      <DateRangePicker
        minimumNights={0}
        startDate={this.state.startDate} // momentPropTypes.momentObj or null,
        endDate={this.state.endDate} // momentPropTypes.momentObj or null,
        displayFormat={this.props.displayFormat}
        onDatesChange={({ startDate, endDate }) =>
          this.handleDateFilter(startDate, endDate)
        } // PropTypes.func.isRequired,
        focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
        onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
        hideKeyboardShortcutsPanel={true}
        isOutsideRange={() => false}
        showClearDates={true}
      />
    );
  }
}

export default DateRangeFilter;



// WEBPACK FOOTER //
// ./app/components/commons/dateFilter/dateFilter.js